/**
 * Copyright 2021-2022 Highway9 Networks Inc.
 */
// biome-ignore lint/style/noRestrictedImports: typed wrappers re-export from react-redux
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import type { RootState, AppDispatch } from ".";

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
